/**
 * @file Shared print-window helpers.
 */

/**
 * Shows a print-related error through the shared confirmation modal.
 * @param {string} message Error message to show.
 * @returns {void}
 */
export function showPrintError(message) {
    import('../ui/confirmationModal.js')
        .then(({ openConfirmationModal }) => {
            openConfirmationModal('Print Report', message, () => {}, false, 'OK');
        })
        .catch(() => {
            console.error(message);
        });
}

/**
 * Opens a blank print window and reports popup blocking.
 * @returns {Window | null} Opened window, or null when blocked.
 */
export function openPrintWindow() {
    const printWindow = window.open('', '_blank');
    if (!printWindow) {
        showPrintError('Pop-up blocked. Please allow pop-ups for this site.');
        return null;
    }
    return printWindow;
}
